<div class="h-available items-center justify-center flex flex-col">
  <div>
    <img src="logo.png" class="logo !h-24" />
  </div>
  <div class="text-4xl font-thin">
    Coming soon...
  </div>
</div>
